/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllRouterUserList } from './routerAction';
   
const initialState = {
    data: {},
    routerUsers: {}
}
const routerSlice = createSlice({
    name: 'router',
    initialState,
    extraReducers: {
        [getAllRouterUserList.fulfilled]: (state, { payload }) => {
            state.routerUsers = payload;
        },
    }
});

export default routerSlice.reducer;